import {
  ArrowRight,
  CancelOutlined,
  Delete,
  DeleteForever,
  ErrorOutline,
  LocalFireDepartmentOutlined,
  MoreVert,
  Share,
  TextFields,
  WarningAmberOutlined,
  Link,
  ContentCopyOutlined,
  LockPersonOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useStyles from "./styles";
import { useState } from "react";
import api from "../../../services/api";
import usePermissao from "../../../hooks/usePermissao";
import AlertModal from "../../alertModal";
import ModalShareMap from "./modalShareMap";
import mapRouteSegment from "../../../utils/easyMaps/mapRouteSegment";
import ModalAcessosMapa from "./modalAcessosMapa";
import dayjs from "dayjs";

function AlertIcons({ styles, number = 0, severity = "warning" }: any) {
  const color =
    severity === "disaster"
      ? "color.zabbixSeverty.disaster"
      : severity === "high"
        ? "color.zabbixSeverty.high"
        : severity === "average"
          ? "color.zabbixSeverty.average"
          : "color.zabbixSeverty.warning";

  const renderTooltip =
    severity === "disaster"
      ? `Alertas de Desastre: ${number}`
      : severity === "high"
        ? `Alertas de Alto Impacto: ${number}`
        : severity === "average"
          ? `Alertas Moderados: ${number}`
          : `Alertas: ${number}`;

  return (
    <>
      <Tooltip title={renderTooltip}>
        <Box sx={[styles.iconsCircle, { backgroundColor: color }]}>
          <Typography sx={styles.subtitleAlert}>{number.toString()}</Typography>

          {severity === "disaster" ? (
            <LocalFireDepartmentOutlined
              sx={{
                ...styles.icons,
              }}
            />
          ) : severity === "high" ? (
            <CancelOutlined sx={styles.icons} />
          ) : severity === "average" ? (
            <ErrorOutline sx={styles.icons} />
          ) : (
            <WarningAmberOutlined sx={styles.icons} />
          )}
        </Box>
      </Tooltip>
    </>
  );
}
function SubMenu({
  anchorElSubmenu,
  openSubmenu,
  setAnchorElSubmenu,
  handleClose,
  setOpenModalShare,
  handleCopy,
  hasLink = false,
  theme = {} as any,
}: any) {
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Popper
      //open={true}
      id="basic-menu-submenu"
      sx={{ zIndex: 1300 }}
      anchorEl={anchorElSubmenu}
      open={openSubmenu}
      placement={isMdDown ? "bottom-end" : "right-start"}
    >
      <Paper
        elevation={4}
        sx={{ bgcolor: theme.palette.mode === "dark" ? "#222222" : "none" }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              handleClose();
              setOpenModalShare(true);
            }}
          >
            <ListItemIcon>
              <Share fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Compartilhar</ListItemText>{" "}
          </MenuItem>
        </MenuList>

        <MenuList>
          <MenuItem
            disabled={!hasLink}
            onClick={() => {
              handleClose();
              handleCopy();
            }}
          >
            <ListItemIcon>
              <Link fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Copiar Link</ListItemText>{" "}
          </MenuItem>
        </MenuList>
      </Paper>
    </Popper>
  );
}

export interface CardMapsHomeProps {
  id?: string;
  mapName?: string;
  tipo?: number;
  hostsNames?: any[];
  hostsCounts?: number;
  popsCounts?: number;
  mapasCounts?: number;
  editMode?: boolean;
  handleDelete?: (id: string) => void;
  index?: number;
  inGroup?: boolean;
  updateTitleInMaps?: (newTitle: string, mapId: string) => void;
  setSnackbar?: (value: any) => void;
  deleteMapsInMaps?: (mapId: string) => void;
  duplicateMapsInMaps?: (mapId: string) => void;
  updateMapTokenInMaps?: (mapToken: any, indexMap: number) => void;
  updateMapAccessInMaps?: (mapId: string, mapAccess: any) => void;
  alertas?: MapAlert[];
  mapas?: any[];
  pops?: MapPop[];
  mapToken?: any;
  mapAccess?: any;
  isRecentMap?: boolean;
  lastOpenedAt?: string;
}

export default function CardMapsHome({
  id = "",
  mapName = "Desconhecido",
  tipo = 0,
  hostsCounts = 0,
  popsCounts = 0,
  mapasCounts = 0,
  editMode = false,
  handleDelete = () => {},
  index = 0,
  inGroup = true,
  updateTitleInMaps = () => {},
  setSnackbar = () => {},
  deleteMapsInMaps = () => {},
  duplicateMapsInMaps = () => {},
  updateMapTokenInMaps = () => {},
  updateMapAccessInMaps = () => {},
  alertas = [],
  mapas = [],
  pops = [],
  mapToken,
  mapAccess,
  isRecentMap,
  lastOpenedAt,
}: CardMapsHomeProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElSubmenu, setAnchorElSubmenu] = useState<null | HTMLElement>(
    null,
  );
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [newTitle, setNewTitle] = useState(mapName);
  const [loadinButtom, setLoadingButtom] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [openModalShare, setOpenModalShare] = useState(false);
  const [openModalAcessos, setOpenModalAcessos] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme() as any;
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));
  const styles = useStyles(theme, editMode);

  const open = Boolean(anchorEl);
  const openSubmenu = Boolean(anchorElSubmenu);

  const currentUser = JSON.parse(localStorage.getItem("1") || "{}");
  const currentUserRole = currentUser?.usuarioCliente?.codigoPermissao ?? "";
  const currentUserId = currentUser?.refreshToken?.usuarioClienteId ?? "";
  const isAdmin = currentUserRole === "adm001" || currentUserRole === "adm002";
  const { canEdit } = usePermissao("easyMaps");

  const handleClick = (event: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCopy = () => {
    const url = `${window.location.origin}/easyMaps/mapa/public/${mapRouteSegment(
      tipo,
    )}/${id}/${mapToken.token}`;
    navigator.clipboard.writeText(url);
    setSnackbar({
      children: "Campo copiado!",
      severity: "info",
    });
  };
  async function handleApiDuplicate() {
    try {
      setLoadingButtom(true);
      const logString = localStorage.getItem("logs");
      const logsId = logString ? JSON.parse(logString)?.id : null;
      const response = await api.post("/easyMaps/map/duplicate", {
        mapId: id,
        logsLoginClienteId: logsId || "",
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível duplicar o mapa",
          severity: "error",
        });
      } else if (response.data) {
        duplicateMapsInMaps(response.data.id);
        setSnackbar({
          children: "Mapa duplicado com sucesso!",
          severity: "success",
        });
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.response?.status === 409
            ? " Título já existente"
            : error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setLoadingButtom(false);
    }
  }
  async function handleApiUpdate() {
    try {
      setLoadingButtom(true);
      const logString = localStorage.getItem("logs");
      const logsId = logString ? JSON.parse(logString)?.id : null;
      const response = await api.put("/easyMaps/map/updateTitle", {
        mapId: id,
        titulo: newTitle,
        logsLoginClienteId: logsId || "",
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível atualizar o título do mapa",
          severity: "error",
        });
      } else {
        if (response.data) {
          setOpenEditDialog(false);
          updateTitleInMaps(newTitle, id);
          setAnchorEl(null);
          setSnackbar({
            children: "Título atualizado com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.response?.status === 409
            ? " Já existe um mapa com esse nome. Escolha um nome diferente."
            : error?.message || " Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setLoadingButtom(false);
    }
  }

  async function handleApiDelete() {
    try {
      try {
        setDisableButton(true);
        const logString = localStorage.getItem("logs");
        const logsId = logString ? JSON.parse(logString)?.id : null;
        const response = await api.post("/easyMaps/map/delete", {
          mapId: id,

          logsLoginClienteId: logsId || "",
        });

        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: Não foi possível excluir o mapa",
            severity: "error",
          });
        } else {
          if (response.data) {
            setOpenDeleteModal(false);
            deleteMapsInMaps(id);
            setAnchorEl(null);
          }
        }
      } catch (error: any) {
        console.error(error);
        setSnackbar({
          children: `Error:${
            error?.message || "Não foi possível se conectar com o servidor"
          } `,
          severity: "error",
        });
      } finally {
        setLoadingButtom(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDisableButton(false);
    }
  }
  const handleMouseDown = (event: any) => {
    const url = `${window.location.origin}/easyMaps/mapa/${mapRouteSegment(
      tipo,
    )}/${id}`;
    if (event.button === 1) {
      window.open(url, "_blank");
    }
  };
  const color =
    tipo === 0
      ? theme.palette.primary.main
      : tipo === 1
        ? theme.palette.secondary.main
        : tipo === 2
          ? theme.palette.color.zabbixSeverty.warning
          : tipo === 3
            ? theme.palette.info.main
            : theme.palette.color.alerts.success;
  return (
    <Card sx={{ ...styles.card, flexGrow: 1 } as any} variant="outlined">
      {editMode && (
        <Tooltip title={"Clique para remover do grupo"} placement="top" arrow>
          <CardActionArea
            sx={styles.deleteCardAction}
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(id);
            }}
          >
            <DeleteForever sx={styles.deleteIcon} color={"primary"} />
          </CardActionArea>
        </Tooltip>
      )}
      <CardActionArea
        sx={styles.cardAction}
        onClick={() => {
          navigate(`/easyMaps/mapa/${mapRouteSegment(tipo)}/${id}`);
        }}
        onMouseDown={handleMouseDown}
      >
        <Box sx={styles.cardType(color)}>
          {tipo === 0 && (
            <Typography sx={styles.typeText(color)}>{"GEO"}</Typography>
          )}
          {tipo === 1 && (
            <Typography sx={styles.typeText(color)}>{"TOP"}</Typography>
          )}
          {tipo === 2 && (
            <Typography sx={styles.typeText(color)}>{"POP"}</Typography>
          )}
          {tipo === 3 && (
            <Typography sx={styles.typeText(color)}>{"FTTH"}</Typography>
          )}
          {tipo === 4 && (
            <Typography sx={styles.typeText(color)}>{"PING"}</Typography>
          )}
        </Box>
        {canEdit && !inGroup && !isRecentMap && (
          <IconButton
            id="options-button"
            sx={styles.options}
            onClick={handleClick}
          >
            <MoreVert />
          </IconButton>
        )}

        <Stack gap={"5px"} mt={2} width={"100%"} minWidth={0}>
          <Tooltip title={mapName}>
            <Typography sx={styles.title}>{mapName}</Typography>
          </Tooltip>
          <Stack gap={"10px"} direction={"row"}>
            <Typography sx={styles.subtitle}>
              {hostsCounts + " Hosts"}
            </Typography>
            <Typography sx={styles.subtitle}>
              {mapasCounts + " Mapas"}
            </Typography>
            <Typography sx={styles.subtitle}>
              {popsCounts + " POP's"}
            </Typography>
          </Stack>
        </Stack>
        <Divider orientation="horizontal" sx={{ width: "100%" }} />
        <Stack direction="row" sx={styles.alerts}>
          {/* <Typography sx={styles.title}>{"Alertas"}</Typography>{" "} */}
          <Typography variant="body1" pr={1}>
            {"Alertas:  "}
          </Typography>
          <Stack direction="row" sx={styles.alertsIcons}>
            <AlertIcons
              styles={styles}
              number={Number(
                alertas.find((alert) => alert.severity === "5")?.value ?? 0,
              )}
              severity={"disaster"}
            />
            <AlertIcons
              styles={styles}
              number={Number(
                alertas.find((alert) => alert.severity === "4")?.value ?? 0,
              )}
              severity={"high"}
            />
            <AlertIcons
              styles={styles}
              number={Number(
                alertas.find((alert) => alert.severity === "3")?.value ?? 0,
              )}
              severity={"average"}
            />
            <AlertIcons
              styles={styles}
              number={Number(
                alertas.find((alert) => alert.severity === "2")?.value ?? 0,
              )}
              severity={"warning"}
            />
          </Stack>
        </Stack>
        {isRecentMap && lastOpenedAt && (
          <Stack direction="row">
            <Typography fontSize={14} color="text.secondary">
              Aberto em:{" "}
              {dayjs(lastOpenedAt).format("DD/MM/YYYY [às] HH:mm:ss")}
            </Typography>
          </Stack>
        )}
      </CardActionArea>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "options-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              handleClose();
              setOpenEditDialog(true);
            }}
          >
            <ListItemIcon>
              <TextFields fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Renomear</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              handleApiDuplicate();
            }}
          >
            <ListItemIcon>
              <ContentCopyOutlined fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Duplicar</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              // handleClose();
              //setOpenModalShare(true);
            }}
            onMouseEnter={(event: any) => {
              setAnchorElSubmenu(event.currentTarget);
            }}
            onMouseLeave={(event: any) => {
              setAnchorElSubmenu(null);
            }}
          >
            <ListItemIcon>
              <Share fontSize="small" color="primary" />
            </ListItemIcon>
            <Stack
              direction={"row"}
              width={"150px"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <ListItemText>Compartilhar</ListItemText>{" "}
              <ArrowRight
                fontSize="small"
                color="action"
                sx={{ transform: isMdDown ? "rotate(90deg)" : "none" }}
              />
            </Stack>
            <SubMenu
              anchorElSubmenu={anchorElSubmenu}
              openSubmenu={openSubmenu}
              setAnchorElSubmenu={setAnchorElSubmenu}
              handleClose={handleClose}
              setOpenModalShare={setOpenModalShare}
              handleCopy={handleCopy}
              hasLink={!!mapToken?.token && mapToken.status}
              theme={theme}
            />
          </MenuItem>
          {isAdmin && (
            <MenuItem
              onClick={() => {
                handleClose();
                setOpenModalAcessos(true);
              }}
            >
              <ListItemIcon>
                <LockPersonOutlined fontSize="small" color="primary" />
              </ListItemIcon>
              <ListItemText>Acessos</ListItemText>
            </MenuItem>
          )}
          <Divider />

          <MenuItem
            onClick={() => {
              handleClose();
              setOpenDeleteModal(true);
            }}
          >
            <ListItemIcon>
              <Delete fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Excluir</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>

      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
        <DialogTitle>Renomear</DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Typography>Nome do mapa</Typography>
          <TextField
            sx={styles.textfield}
            value={newTitle}
            onChange={(event: any) => {
              const re = (s: string) =>
                s.replace(
                  /(?:\p{Extended_Pictographic}|\uFE0F|\u200D|\u{1F3FB}-\u{1F3FF})+/gu,
                  "",
                );
              const cleaned = re(event.target.value);
              setNewTitle(cleaned);
            }}
            autoFocus
            autoComplete="off"
            placeholder="Nome do mapa"
            id="Nome do mapa"
            type="text"
            size="small"
            fullWidth
            onKeyDown={(event: any) => {
              if (event.key === "Enter") {
                document.getElementById("confirmButton")?.click();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenEditDialog(false);
              setNewTitle(mapName);
            }}
            color="primary"
          >
            Cancelar
          </Button>
          <Button
            id="confirmButton"
            sx={styles.confirmButton}
            disabled={loadinButtom || newTitle.length === 0}
            onClick={handleApiUpdate}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <ModalShareMap
        id={id}
        tipo={tipo}
        mapName={mapName}
        openModalShare={openModalShare}
        setOpenModalShare={setOpenModalShare as any}
        mapas={[...mapas, ...pops.filter(({ mapRefId }) => !!mapRefId)] as any}
        setSnackbar={setSnackbar as any}
        updateMapTokenInMaps={updateMapTokenInMaps as any}
        index={index}
        mapToken={mapToken}
      />
      <ModalAcessosMapa
        id={id}
        mapName={mapName}
        openModal={openModalAcessos}
        setOpenModal={setOpenModalAcessos as any}
        mapAccess={mapAccess}
        setSnackbar={setSnackbar as any}
        updateMapAccessInMaps={updateMapAccessInMaps as any}
        currentUserId={currentUserId}
      />
      <AlertModal
        openModal={openDeleteModal}
        setOpenModal={setOpenDeleteModal}
        confirmar={disableButton}
        handleButton={handleApiDelete}
        severity={"error"}
        singleButton={false}
      />
    </Card>
  );
}
//export { CardMapsHome };
